import { useEffect } from 'react';
import {
  useSharedValue,
  useAnimatedStyle,
  withRepeat,
  withTiming,
  Easing,
  interpolateColor,
} from 'react-native-reanimated';
import { alert, brand, icon } from 'src/theme/colors';

interface UseHeartBeatAnimationProps {
  showWarning: boolean;
  backgroundColor?: string;
}

export const useHeartBeatAnimation = ({ showWarning, backgroundColor }: UseHeartBeatAnimationProps) => {
  const heartbeatScaleSV = useSharedValue(1);
  const heartbeatOpacitySV = useSharedValue(0.85);
  const warningProgressSV = useSharedValue(showWarning ? 1 : 0);

  useEffect(() => {
    if (showWarning) {
      heartbeatScaleSV.value = withRepeat(
        withTiming(1.5, {
          duration: 1000,
          easing: Easing.ease,
        }),
        -1,
        false,
      );

      heartbeatOpacitySV.value = withRepeat(
        withTiming(0, {
          duration: 1000,
          easing: Easing.ease,
        }),
        -1,
        false,
      );
    } else {
      heartbeatScaleSV.value = 1;
      heartbeatOpacitySV.value = 0.85;
    }

    warningProgressSV.value = withTiming(showWarning ? 1 : 0, {
      duration: 1000,
      easing: Easing.cubic,
    });
  }, [showWarning]);

  const heartbeatAnimatedStyle = useAnimatedStyle(() => ({
    transform: [{ scale: heartbeatScaleSV.value }],
    opacity: heartbeatOpacitySV.value,
  }));

  const badgeAnimatedStyle = useAnimatedStyle(() => ({
    backgroundColor: interpolateColor(
      warningProgressSV.value,
      [0, 0.5, 1],
      [backgroundColor ?? brand.main.water, icon.iconSuccess, alert.alertRed],
    ),
  }));

  return {
    heartbeatAnimatedStyle,
    badgeAnimatedStyle,
  };
};
